import React, { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DataViewerWrapper(props) {
  const {
    Component,
    ...rest
  } = props;
  const {
    onFilterChange,
    filterName,
    forwardRef
  } = props;
  useEffect(() => {
    return () => {
      onFilterChange?.({
        data: filterName,
        value: null,
        isOnUnmount: true
      });
    };
  }, []);
  return /*#__PURE__*/_jsx(Component, {
    ...rest,
    ref: forwardRef,
    onFilterChange: onFilterChange,
    filterName: filterName
  });
}